import { fetchProductById } from './products';
import { getSportByName, getSportBySlug, sportToSlug } from '../utils/sports';

const cache = new Map();
const inflight = new Map();

export function rememberProductSportSlug(productId, product) {
  if (!productId || !product) return;
  const sport =
    getSportBySlug(product.sport) ||
    getSportByName(product.sport) ||
    getSportByName(product.category) ||
    getSportBySlug(sportToSlug(product.category));
  cache.set(productId, sport?.slug || '');
}

export async function resolveProductSportSlug(productId) {
  if (!productId) return '';
  if (cache.has(productId)) return cache.get(productId);

  if (inflight.has(productId)) {
    return inflight.get(productId);
  }

  const request = fetchProductById(productId)
    .then(product => {
      const sport =
        getSportBySlug(product.sport) ||
        getSportByName(product.sport) ||
        getSportByName(product.category) ||
        getSportBySlug(sportToSlug(product.category));
      const slug = sport?.slug || '';
      cache.set(productId, slug);
      inflight.delete(productId);
      return slug;
    })
    .catch(() => {
      cache.set(productId, '');
      inflight.delete(productId);
      return '';
    });

  inflight.set(productId, request);
  return request;
}
